import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { ButtonGroup, Button } from 'react-bootstrap';
import { pickBy } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'qs';

import Dropdown from '../../../../../components/Dropdown/Default';

import { setPageFiltersQuery } from '../../../../../redux/actions/reports';
import { useWindowSize } from '../../../../../utils/hooks/useWindowSize';

const Filters = ({ filters }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { width } = useWindowSize();
  const reports = useSelector((state) => state.reports);
  const { pageFiltersQuery } = reports;

  const queryString = qs.parse(location.search.slice(1));

  const [localFilters, setLocalFilters] = useState({
    mode: filters?.modes?.find((mode) => mode.selected) || null,
    staff: filters?.staff?.find((staff) => staff.selected) || null,
    year: filters?.years?.find((year) => year.selected) || null,
  });

  const showStaff = useMemo(() => {
    const selectedMode = filters?.modes?.find((mode) => mode.selected);
    return filters?.staff?.length && (selectedMode?.code === 'sm' || selectedMode?.code === 'answered');
  }, [filters]);

  const onChangeMode = (mode) => {
    setLocalFilters((prevState) => ({ ...prevState, mode }));
    dispatch(setPageFiltersQuery({ ...pageFiltersQuery, mode: mode.code }));
    history.push({
      pathname: location.pathname,
      search: qs.stringify(pickBy({ ...queryString, mode: mode.code })),
    });
  };

  const onChangeStaff = (staff) => {
    setLocalFilters((prevState) => ({ ...prevState, staff: filters?.staff?.find((item) => item.id === staff) || null }));
    dispatch(setPageFiltersQuery({ ...pageFiltersQuery, staff: filters?.staff?.find((item) => item.id === staff)?.id?.toString() || null }));
    history.push({
      pathname: location.pathname,
      search: qs.stringify(pickBy({ ...queryString, staff })),
    });
  };

  const onChangeYear = (year) => {
    setLocalFilters((prevState) => ({ ...prevState, year: filters?.years?.find((item) => item.id === year) || null }));
    dispatch(setPageFiltersQuery({ ...pageFiltersQuery, year: filters?.years?.find((item) => item.id === year)?.id?.toString() || null }));
    history.push({
      pathname: location.pathname,
      search: qs.stringify(pickBy({ ...queryString, year })),
    });
  };

  useEffect(() => {
    setLocalFilters({
      mode: filters?.modes?.find((mode) => mode.selected) || null,
      staff: filters?.staff?.find((staff) => staff.selected) || null,
      year: filters?.years?.find((year) => year.selected) || null,
    });
  }, [filters]);

  return (
    <div className="reports-filters__items">
      {filters?.modes?.length ? (
        <div className="reports-filters__items-block">
          <ButtonGroup>
            {filters?.modes?.map((mode) => (
              <Button
                key={mode.code}
                active={mode.code === localFilters?.mode?.code}
                onClick={() => onChangeMode(mode)}
              >
                {mode?.title}
              </Button>
            ))}
          </ButtonGroup>
        </div>
      ) : null}

      {showStaff ? (
        <div className="reports-filters__items-block staff">
          <Dropdown
            handleSelect={(key) => onChangeStaff(key)}
            title={localFilters?.staff?.title || ''}
            items={filters?.staff}
            pullRight={!(width < 768)}
            classForBtnDrop="font__weight-med"
            dropStyle="default"
            simple
          />
        </div>
      ) : null}

      {filters?.years?.length ? (
        <div className="reports-filters__items-block year">
          <Dropdown
            handleSelect={(key) => onChangeYear(key)}
            title={localFilters?.year?.title || ''}
            items={filters?.years}
            classForBtnDrop="font__weight-med"
            dropStyle="default"
            pullRight={false}
            simple
          />
        </div>
      ) : null}
    </div>
  );
};

Filters.propTypes = {
  filters: PropTypes.object,
};

export default Filters;
